import type { Preference } from '@/signupElement/Signup.types';
import classnames from 'classnames';
import type React from 'react';
import { input, labelStyle } from '../../Signup.css';
interface SelectProps {
  preference: Preference;
  style?: React.CSSProperties;
  isLabelVisible?: boolean;
}

const Select: React.FC<SelectProps> = ({ preference, style = {}, isLabelVisible }) => {
  return (
    <div className="flex flex-col gap-1">
      {isLabelVisible && (
        <label className={classnames(labelStyle, 'text-left w-full')} htmlFor={`preference_${preference?.id}`}>
          {preference?.name}
          {preference?.required && <span>*</span>}
        </label>
      )}
      <select
        name={`field_${preference?.custom_field_id}`}
        style={style}
        className={input}
        id={`preference_${preference?.id}`}
        required={preference?.required}
      >
        <option value="">{preference?.placeholder || 'Select an option'}</option>
        {preference?.subscriber_preference_options.map((option) => (
          <option key={option.id} value={option.value}>
            {option.value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
